/* ============================================================
   EVAYA — Mobile system behaviours (2026 rebuild)
   Drawer · scroll-reveal · sticky buy bar · PDP options · FAQ filter
   ============================================================ */
(function () {
  function ready(fn){ document.readyState!=="loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); }

  ready(function () {
    /* ---- Drawer ---- */
    var burger = document.querySelector(".nav-burger");
    var drawer = document.querySelector(".m-drawer");
    var scrim  = document.querySelector(".m-scrim");
    if (burger && drawer && scrim) {
      var closeBtn = drawer.querySelector(".m-close");
      var openD = function(){ drawer.classList.add("open"); scrim.classList.add("open"); document.body.classList.add("m-lock"); burger.setAttribute("aria-expanded","true"); };
      var closeD = function(){ drawer.classList.remove("open"); scrim.classList.remove("open"); document.body.classList.remove("m-lock"); burger.setAttribute("aria-expanded","false"); };
      burger.addEventListener("click", openD);
      scrim.addEventListener("click", closeD);
      if (closeBtn) closeBtn.addEventListener("click", closeD);
      document.addEventListener("keydown", function(e){ if(e.key==="Escape") closeD(); });
      drawer.querySelectorAll(".m-nav a, .m-drawer-foot a").forEach(function(a){
        a.addEventListener("click", function(){ setTimeout(closeD,120); });
      });
    }

    /* ---- Scroll reveal ---- */
    var reveals = document.querySelectorAll(".reveal");
    if (reveals.length && "IntersectionObserver" in window) {
      document.documentElement.classList.add("anim");
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add("in"); io.unobserve(e.target); } });
      }, { threshold:.12, rootMargin:"0px 0px -8% 0px" });
      reveals.forEach(function(el){ io.observe(el); });
    } else {
      reveals.forEach(function(el){ el.classList.add("in"); });
    }

    /* ---- Sticky buy bar: show after the buy box scrolls past ---- */
    var buybar = document.querySelector(".buybar");
    var anchor = document.querySelector("[data-buybar-after]");
    if (buybar && anchor && "IntersectionObserver" in window) {
      var bo = new IntersectionObserver(function(es){
        es.forEach(function(e){ buybar.classList.toggle("show", !e.isIntersecting && e.boundingClientRect.top < 0); });
      }, { threshold:0 });
      bo.observe(anchor);
    }

    /* ---- PDP option selectors (size / firmness / strap) ---- */
    document.querySelectorAll("[data-opt-group]").forEach(function(group){
      group.addEventListener("click", function(e){
        var btn = e.target.closest("[data-opt]"); if(!btn) return;
        group.querySelectorAll("[data-opt]").forEach(function(b){ b.classList.remove("active"); });
        btn.classList.add("active");
        var valEl = group.querySelector("[data-opt-value]");
        if (valEl) valEl.textContent = btn.getAttribute("data-label") || btn.getAttribute("data-opt");
        var price = btn.getAttribute("data-price");
        if (price) {
          document.querySelectorAll("[data-price-out]").forEach(function(p){ p.textContent = price; });
        }
      });
    });

    /* ---- FAQ live search + category filter ---- */
    var faqRoot = document.querySelector("[data-faq]");
    if (faqRoot) {
      var input  = faqRoot.querySelector("[data-faq-input]");
      var clear  = faqRoot.querySelector("[data-faq-clear]");
      var count  = faqRoot.querySelector("[data-faq-count]");
      var chips  = faqRoot.querySelectorAll("[data-cat-chip]");
      var items  = Array.prototype.slice.call(faqRoot.querySelectorAll("[data-q]"));
      var groups = Array.prototype.slice.call(faqRoot.querySelectorAll("[data-chapter]"));
      var empty  = faqRoot.querySelector("[data-faq-empty]");
      var cat = "all";

      function apply(){
        var term = (input ? input.value : "").trim().toLowerCase();
        var shown = 0;
        items.forEach(function(it){
          var hay = (it.getAttribute("data-q")+" "+it.textContent).toLowerCase();
          var okCat = (cat==="all") || it.getAttribute("data-cat")===cat;
          var okTerm = !term || hay.indexOf(term)>-1;
          var vis = okCat && okTerm;
          it.style.display = vis ? "" : "none";
          if (vis) shown++;
        });
        groups.forEach(function(g){
          var any = g.querySelectorAll("[data-q]:not([style*='display: none'])").length;
          g.style.display = any ? "" : "none";
        });
        if (count) count.textContent = shown;
        if (empty) empty.style.display = shown ? "none" : "block";
        if (clear) clear.style.display = term ? "inline" : "none";
      }
      if (input) input.addEventListener("input", apply);
      if (clear) clear.addEventListener("click", function(){ input.value=""; apply(); input.focus(); });
      chips.forEach(function(c){
        c.addEventListener("click", function(){
          chips.forEach(function(x){ x.classList.remove("active"); });
          c.classList.add("active");
          cat = c.getAttribute("data-cat-chip");
          if (input) input.value="";
          apply();
          faqRoot.scrollIntoView ? null : null;
        });
      });
      apply();
    }
  });
})();

/* ---- Anatomy band diagram: tap a layer to expand its description ---- */
document.addEventListener("DOMContentLoaded", function(){
  document.querySelectorAll(".evaya-m .anat").forEach(function(anat){
    var bands = anat.querySelectorAll(".band");
    bands.forEach(function(b){
      b.addEventListener("click", function(){
        var was = b.classList.contains("open");
        bands.forEach(function(x){ x.classList.remove("open"); });
        if(!was) b.classList.add("open");
      });
    });
  });
});

/* ---- Mobile brand search overlay: open from nav icon, close button ---- */
document.addEventListener("DOMContentLoaded", function(){
  var trigger = document.querySelector(".evaya-m .nav-search");
  var overlay = document.getElementById("evmSearch");
  if(!trigger || !overlay) return;
  var field = overlay.querySelector(".evm-search-field");
  var closeBtn = overlay.querySelector(".evm-search-close");
  trigger.addEventListener("click", function(e){
    e.preventDefault();
    overlay.classList.add("open");
    overlay.setAttribute("aria-hidden","false");
    if(field) setTimeout(function(){ field.focus(); }, 90);
  });
  if(closeBtn) closeBtn.addEventListener("click", function(){
    overlay.classList.remove("open");
    overlay.setAttribute("aria-hidden","true");
  });
});

/* ---- Mobile PDP gallery: tap a thumbnail to swap the hero image ---- */
document.addEventListener("DOMContentLoaded", function(){
  document.querySelectorAll(".evaya-m .gal-thumbs").forEach(function(thumbs){
    var container = thumbs.closest("section") || thumbs.parentElement;
    var heroImg = container ? container.querySelector(".gal-hero img") : null;
    if(!heroImg) return;
    var ts = thumbs.querySelectorAll(".t");
    ts.forEach(function(t){
      t.addEventListener("click", function(){
        var img = t.querySelector("img");
        if(img){ heroImg.src = img.getAttribute("src"); }
        ts.forEach(function(x){ x.classList.remove("active"); });
        t.classList.add("active");
      });
    });
  });
});

/* ---- Shop the Lineup accordion: tap a row to expand; recommended open by default ---- */
document.addEventListener("DOMContentLoaded", function(){
  document.querySelectorAll(".evaya-m .ll .m-list").forEach(function(list){
    var cards = list.querySelectorAll(".m-card");
    cards.forEach(function(card){
      var head = card.querySelector(".m-rowhead");
      if(!head) return;
      head.addEventListener("click", function(){
        var open = card.classList.toggle("is-open");
        head.setAttribute("aria-expanded", String(open));
      });
    });
    var rec = list.querySelector(".m-card.is-recommended");
    if(rec){ rec.classList.add("is-open"); var h = rec.querySelector(".m-rowhead"); if(h) h.setAttribute("aria-expanded","true"); }
  });
});
